import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "FacePending"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M12 1.5C6.20101 1.5 1.5 6.20101 1.5 12C1.5 17.799 6.20101 22.5 12 22.5C17.799 22.5 22.5 17.799 22.5 12C22.5 9.21523 21.3938 6.54451 19.4246 4.57538C17.4555 2.60625 14.7848 1.5 12 1.5ZM6.75 10.125C6.75 9.08947 7.58947 8.25 8.625 8.25C9.12351 8.24596 9.60277 8.44221 9.95528 8.79472C10.3078 9.14723 10.504 9.62649 10.5 10.125C10.5 11.1605 9.66053 12 8.625 12C7.58947 12 6.75 11.1605 6.75 10.125ZM13.5 10.125C13.5 9.08947 14.3395 8.25 15.375 8.25C15.8735 8.24596 16.3528 8.44221 16.7053 8.79472C17.0578 9.14723 17.254 9.62649 17.25 10.125C17.25 11.1605 16.4105 12 15.375 12C14.3395 12 13.5 11.1605 13.5 10.125ZM3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/FacePending.vue"]]);
